// extracted by mini-css-extract-plugin
export default {"textfield":"LabeledTextarea_textfield__8seik","heading":"LabeledTextarea_heading__-qqHU"};